import { notFoundRouterRoute } from '@townsquare/404-page-view/__router-route';
import { appsResource } from '@townsquare/apps-store/resource';
import { appsRoute } from '@townsquare/apps-view/__router-route';
import { popupAuthRoute } from '@townsquare/auth/popup-login';
import { capabilityProviderResource } from '@townsquare/capability-provider/resource';
import { agentEmbedRouterRoute, teamEmbedRouterRoute } from '@townsquare/embeds/__router-route';
import { emptyOrNonProvisionedStatusUpdateStateRouterRoute } from '@townsquare/empty-or-not-provisioned-state/__router-route';
import { notificationsRouterRoute } from '@townsquare/notifications-view/__router-route';
import { peopleDirectoryRouterRoute } from '@townsquare/people-directory-view/__router-route';
import {
	agentProfileRouterRoute,
	kudosProfileRouterRoute,
	profileRouterRoute,
	teamProfileRouterRoute,
} from '@townsquare/ptc-directory-view/__router-route';
import { applyResourcesToRoute, expandGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute, HomepageRouteType, HomepageRoutes } from '@townsquare/router/route-types';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';
import { searchConfigurationResource } from '@townsquare/search-config-resource';
import { teamsAppGlobalSearchRouterRoute } from '@townsquare/search-view/__router-route';
import { noWorkspacePersonalSettingsRouterRoute } from '@townsquare/settings-view/__router-route';
import { staffDirectoryRouterRoute } from '@townsquare/staff-directory-view/__router-route';
import { teamsAppAgentsDirectoryRouterRoute } from '@townsquare/teams-app-agents-directory-view/__router-route';
import { teamsAppForYouRouterRoute } from '@townsquare/teams-app-for-you-view/__router-route';
import { kudosDirectoryRouterRoute } from '@townsquare/teams-app-kudos-directory-view/__router-route';
import { aggTeamsDirectoryRouterRoute } from '@townsquare/agg-teams-directory-view/__router-route';
import { teamsDirectoryRouterRoute } from '@townsquare/teams-directory-view/__router-route';
import { teamsSettingsRouterRoute } from '@townsquare/teams-settings-view/__router-route';
import { lookupRedirectActionRouterRoute } from '@townsquare/url-actions/lookup-redirect/__router-route';
import { reactionUpdateActionRouterRoute } from '@townsquare/url-actions/reaction-update/__router-route';
import { searchRedirectActionRouterRoute } from '@townsquare/url-actions/search-redirect/__router-route';

// When adding a new route, please also add it to the route-sanity-check E2E test
export const routeDefinitions: HomepageRoutes = [
	// Actions
	lookupRedirectActionRouterRoute,
	reactionUpdateActionRouterRoute,
	searchRedirectActionRouterRoute,

	// Embed routes
	teamEmbedRouterRoute,

	// Routes
	teamsAppGlobalSearchRouterRoute,
	teamsSettingsRouterRoute,
	// teamsDirectoryRouterRoute needs to come before other directory routes
	teamsDirectoryRouterRoute,
	peopleDirectoryRouterRoute,
	teamsAppAgentsDirectoryRouterRoute,
	kudosDirectoryRouterRoute,
	staffDirectoryRouterRoute,
	teamsAppForYouRouterRoute,
	profileRouterRoute,
	kudosProfileRouterRoute,
	teamProfileRouterRoute,
	agentProfileRouterRoute,
	agentEmbedRouterRoute,
	appsRoute,
	aggTeamsDirectoryRouterRoute,

	// Fallback
	popupAuthRoute,
	notFoundRouterRoute,
];

export const noWorkspaceRouteDefinitions: GlobalHomePageRoute[] = [
	notificationsRouterRoute,
	emptyOrNonProvisionedStatusUpdateStateRouterRoute,
	noWorkspacePersonalSettingsRouterRoute,
	teamsAppGlobalSearchRouterRoute,
	agentProfileRouterRoute,
	agentEmbedRouterRoute,

	// Fallback
	notFoundRouterRoute,
];

export const routes: HomepageRouteType[] = routeDefinitions
	.flatMap<HomepageRouteType>(route => {
		if (route.routeType === 'global') {
			return expandGlobalRoute(route);
		}

		return route;
	})
	.map(route => {
		if (route.routeType === 'global' || route.routeType === 'site') {
			route = applyResourcesToRoute(route, [
				appsResource,
				rovoEntitlementResource,
				searchConfigurationResource,
				capabilityProviderResource,
			]);
		}

		return route;
	});

export const noWorkspaceRoutes: HomepageRouteType[] = noWorkspaceRouteDefinitions
	.flatMap<HomepageRouteType>(route => {
		if (route.routeType === 'global') {
			return expandGlobalRoute(route);
		}

		return route;
	})
	.map(route => {
		if (route.routeType === 'global' || route.routeType === 'site') {
			route = applyResourcesToRoute(route, [appsResource, rovoEntitlementResource, searchConfigurationResource]);
		}

		return route;
	});
